import { Tune, ArrowForwardIos } from "@mui/icons-material";
import { Button, Divider, Typography } from "@mui/material";
import { useState } from "react";

import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import HNSColors from "../../../ui library/HNSColors";

export default function FiltersButton({ children }) {
  const [openFilter, setOpenFilter] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Tune />}
        onClick={() => setOpenFilter(true)}
        size="small"
        sx={{
          padding: "10px 18px",
          gap: "10px",
          borderRadius: "999px",
          textTransform: "none",
          backgroundColor: HNSColors.neutrals[900],
          borderColor: HNSColors.secondary[400],
          color: HNSColors.secondary[400],
          ml: 3,
          "&:hover": {
            backgroundColor: HNSColors.secondary[900],
            borderColor: "transparent",
            color: HNSColors.secondary[400],
          },
        }}
      >
        Filters
      </Button>

      <aside
        role="dialog"
        aria-label="Filter panel"
        className={`absolute left-0 top-0 z-[1000] flex h-full w-[450px] transform flex-col rounded-bl-[10px] rounded-tl-[10px] border-r border-[#ececec] bg-white transition-transform duration-300 ease-out will-change-transform ${
          openFilter
            ? "translate-x-0 shadow-[4px_0_6px_-2px_rgba(0,0,0,0.2)]"
            : "-translate-x-full shadow-none"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <Typography className="p-2 pl-4 text-lg font-bold">Filter Documents:</Typography>
          <CustomIconButton
            tooltipText="Hide Filter Menu"
            classes="rotate-180 p-2"
            handleOnClick={() => setOpenFilter(false)}
            iconVisible={true}
            CustomIcon={<ArrowForwardIos className="text-sky-600" />}
          />
        </div>
        <Divider />
        {children}
      </aside>
    </>
  );
}
